import { FilterContainer } from '@/common/dashboard/FilterContainer';
import { Form } from '@/common/form/Form';
import { FormFields } from '@/common/form/rendering/FormFields';
import { useNavStateSync } from '@/common/hooks/navState/useNavStateSync';
import { ContentBox } from '@/common/layout/ContentBox.jsx';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useEffect, useRef, useState } from 'react';
import { GpoRosterGrid } from './GpoRosterGrid';

export const GpoRosterDashboard = () => {
  const rsrc = useRsrc();
  const { navState } = useNavState();

  const [fieldDefs, setFieldDefs] = useState();
  const [formValues, setFormValues] = useNavStateSync('formValues');
  const defaultFormValues = useRef();

  useEffect(() => {
    rsrc
      .data('md', 'GPO_ROSTER_DASHBOARD_DATA_PLUGIN', {})
      .then((res) => {
        setFieldDefs([
          {
            field: 'periodId',
            displayName: 'Period',
            type: 'DROPDOWN',
            values: [
              { value: null, displayName: 'All Periods' },
              ...res.periods.map((p) => ({ value: p.id, displayName: p.code })),
            ],
          },
          {
            field: 'gpo',
            displayName: 'GPO',
            type: 'DROPDOWN',
            values: [{ value: null, displayName: 'All' }, ...res.gpos],
          },
          {
            field: 'searchType',
            displayName: 'Search By',
            type: 'DROPDOWN',
            values: [
              { value: 'GPO_ID', displayName: 'GPO ID' },
              { value: 'HIN', displayName: 'HIN' },
              { value: 'DEA', displayName: 'DEA' },
            ],
          },
          {
            field: 'searchValue',
            displayName: 'Search Value',
          },
        ]);

        defaultFormValues.current = {
          periodId: res.periods[0]?.id,
          gpo: null,
          searchType: 'GPO_ID',
          searchValue: '',
        };

        if (!navState.formValues || navState.formValues.periodId == null) {
          setFormValues(defaultFormValues.current);
        }
      })
      .catch(() => {
        setFieldDefs([
          {
            field: 'periodId',
            displayName: 'Period',
            type: 'DROPDOWN',
            values: [{ value: null, displayName: 'All Periods' }],
          },
          {
            field: 'gpo',
            displayName: 'GPO',
            type: 'DROPDOWN',
            values: [{ value: null, displayName: 'All' }],
          },
          {
            field: 'searchType',
            displayName: 'Search By',
            type: 'DROPDOWN',
            values: [
              { value: 'GPO_ID', displayName: 'GPO ID' },
              { value: 'HIN', displayName: 'HIN' },
              { value: 'DEA', displayName: 'DEA' },
            ],
          },
          {
            field: 'searchValue',
            displayName: 'Search Value',
          },
        ]);

        defaultFormValues.current = {
          periodId: null,
          gpo: null,
          searchType: 'GPO_ID',
          searchValue: '',
        };

        if (!navState.formValues || navState.formValues.periodId == null) {
          setFormValues(defaultFormValues.current);
        }
      });
  }, []);

  if (!fieldDefs) {
    return;
  }

  return (
    <ContentBox>
      {/* Title */}

      <Title icon={fas.faTasks} title="GPO Roster Dashboard" />

      {/* Filters */}
      <Form formValues={formValues} setFormValues={setFormValues}>
        <FormFields fieldDefs={fieldDefs} container={FilterContainer} />
      </Form>

      <GpoRosterGrid
        periodId={formValues?.periodId}
        gpo={formValues?.gpo}
        searchType={formValues?.searchType}
        searchValue={formValues?.searchValue}
      />
    </ContentBox>
  );
};
